import {
    FETCH_PAYMENT_METHODS,
    FETCH_PAYMENT_METHODS_SUCCESS,
    FETCH_PAYMENT_METHODS_FAILED,
    UPDATE_WALLET_BALANCE,
    UPDATE_WALLET_BALANCE_SUCCESS,
    UPDATE_WALLET_BALANCE_FAILED,
    CLEAR_PAYMENT_MESSAGES,
    UPDATE_PAYMENT_METHOD
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, update, push } from "firebase/database";

export const fetchPaymentMethods = () => (dispatch) => {

    const {
      config,
      paymentSettingsRef
    } = firebase;
  
    dispatch({
      type: FETCH_PAYMENT_METHODS,
      payload: null
    });

    const usertype = store.getState().auth.profile.usertype;

    if(usertype == 'admin'){
        onValue(paymentSettingsRef, snapshot => {
            const data = snapshot.val(); 
            if(data){
              dispatch({
                type: FETCH_PAYMENT_METHODS_SUCCESS,
                payload: data
              });
            } else {
              dispatch({
                type: FETCH_PAYMENT_METHODS_FAILED,
                payload: store.getState().languagedata.defaultLanguage.no_provider_found,
              });
            }
          });
    } else { 
        const settings = store.getState().settingsdata.settings;
        let host = 'https://api.tasirimkurye.com';
        let url = `${host}/get_providers`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.length > 0) {
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_SUCCESS,
                        payload: responseJson,
                    });
                }else{
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_FAILED,
                        payload: store.getState().languagedata.defaultLanguage.no_provider_found,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_PAYMENT_METHODS_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.provider_fetch_error + ": " + error.toString(),
                });
            });
    }
  };

  export const editPaymentMethods = (data) => (dispatch) => {
    const {
        paymentSettingsRef
    } = firebase;
    dispatch({
      type: UPDATE_PAYMENT_METHOD,
      payload: data 
    });
    update(paymentSettingsRef, data);
  }
  


export const clearMessage = () => (dispatch) => {
    dispatch({
        type: CLEAR_PAYMENT_MESSAGES,
        payload: null,
    });    
};


const createWalletIdempotencyKey = () =>
    `wallet-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;

const readJsonResponse = async (response) => {
    try {
        return await response.json();
    } catch (error) {
        return {};
    }
};

// Wallet balances and history are authoritative on the server. This action intentionally
// never writes either RTDB path and returns the completed HTTPS-function response to callers.
export const adjustWalletAsAdmin = ({ uid, amount, operation, reason, idempotencyKey }) => async (dispatch) => {
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    try {
        const { auth, config } = firebase;
        if (!auth?.currentUser) {
            throw new Error('Authentication is required.');
        }
        if (!config?.projectId) {
            throw new Error('Firebase project configuration is unavailable.');
        }

        const idToken = await auth.currentUser.getIdToken();
        const response = await fetch(
            `https://us-central1-${config.projectId}.cloudfunctions.net/admin_wallet_adjust`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`,
                },
                body: JSON.stringify({ uid, amount, operation, reason, idempotencyKey }),
            }
        );
        const result = await readJsonResponse(response);
        if (!response.ok) {
            const error = new Error(result.error || 'Wallet adjustment failed.');
            error.code = result.code;
            throw error;
        }

        dispatch({
            type: UPDATE_WALLET_BALANCE_SUCCESS,
            payload: null
        });
        return result;
    } catch (error) {
        const message = error?.code
            ? `${error.code}: ${error.message}`
            : (error?.message || 'Wallet adjustment failed.');
        dispatch({
            type: UPDATE_WALLET_BALANCE_FAILED,
            payload: message,
        });
        throw error;
    }
};

// Retains the legacy call shape while routing admin credits through the authenticated backend.
// The web form supplies one stable key per deliberate submit; callers without one remain safe.
export const addToWallet = (uid, amount, idempotencyKey) => (dispatch) =>
    dispatch(adjustWalletAsAdmin({
        uid,
        amount,
        operation: 'credit',
        reason: 'Admin Credit',
        idempotencyKey: idempotencyKey || createWalletIdempotencyKey(),
    }));


export const withdrawBalance = (profile, amount) => async (dispatch) => {

    const {
        withdrawRef,
    } = firebase;
    
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    push(withdrawRef, {
        uid : profile.uid,
        name : profile.firstName +  ' ' + profile.lastName,
        amount : parseFloat(amount),
        date : new Date().getTime(),
        bankName : profile.bankName? profile.bankName : '',
        bankCode : profile.bankCode? profile.bankCode : '',
        bankAccount : profile.bankAccount? profile.bankAccount : '',
        processed:false
    });
       
};

// Both admin payment-issue endpoints share the same shape as adjustWalletAsAdmin: the caller
// is authenticated with a Firebase ID token and the function itself re-checks that the actor
// is an admin, so nothing here is trusted client-side.
const callAdminPaymentEndpoint = async (endpoint, payload) => {
    const { auth, config } = firebase;
    if (!auth?.currentUser) {
        throw new Error('Authentication is required.');
    }
    if (!config?.projectId) {
        throw new Error('Firebase project configuration is unavailable.');
    }

    const idToken = await auth.currentUser.getIdToken();
    const response = await fetch(
        `https://us-central1-${config.projectId}.cloudfunctions.net/${endpoint}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`,
            },
            body: JSON.stringify(payload || {}),
        }
    );
    const result = await readJsonResponse(response);
    if (!response.ok) {
        const error = new Error(result.error || 'İşlem tamamlanamadı.');
        error.code = result.code;
        throw error;
    }
    return result;
};

export const fetchPaymentIssues = () => async () => {
    try {
        return await callAdminPaymentEndpoint('admin_payment_issues', {});
    } catch (error) {
        return { success: false, error: error.message, code: error.code, issues: [] };
    }
};

// action: 'refund' | 'reverse' | 'close'. The server recomputes the amount from the wallet
// ledger, so a stale screen cannot move a figure that is no longer correct.
export const resolvePaymentIssue = ({ bookingId, customerUid, action, note }) => async () => {
    try {
        return await callAdminPaymentEndpoint('admin_payment_issue_resolve', { bookingId, customerUid, action, note });
    } catch (error) {
        return { success: false, error: error.message, code: error.code };
    }
};
